export default "__VITE_ASSET__CzWW12cU__"